<template>

    <div class="text-black">
        <a class="btn-secondary" v-bind:href="href"><i class="fa fa-floppy-o"></i> Excel</a>
    </div>

</template>

<script>
    import Data from "../Data";

    export default {

        data()  {
            return {
                source: Data,
                chart: {},
            }
        },

        computed: {
            href: function () {
                return "/panels/" + Data.id + "/excel";
            }
        },

        methods: {

        }
    }
</script>